<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div class="left-box">
				<div style="font-weight: 700;font-size: 16px;margin-top: 21px;">企业首页</div>
				<div style="width: 396px;height: 790px;margin-top: 45px;">
					<!-- <img  style="width: 396px;height: 790px;" src="../../assets/Home/1.png" /> -->
					<div v-if="curIndex==1" class="left-content">
						<div style="width: 100%;height: 375px;position: relative;" 
						:style="'background: url('+tempBg+');'" class="img-top">
							<img style="width: 100%;height: 12px;" src="../../assets/Home/zhaungtailan.png" />
							<div class="d-flex a-center" style="box-sizing: border-box;padding: 5px 11px;">
								<img style="width: 16px;height: 16px;" src="../../assets/Home/fanhui.png" />
								<img style="width: 76px;height: 26px;margin-left: auto;" src="../../assets/Home/wxzt.png" />
							</div>
							<div class="d-flex" style="box-sizing: border-box;padding: 0 13px;margin-top: 26px;">
								<img style="width: 76px;height: 76px;" src="../../assets/Home/touxiang.png" />
								<div style="margin-left: 12px;flex: 1;">
									<div class="d-flex a-center" style="color: #FFFFFF">
										<div style="font-size: 24px;">张斌成</div>
										<div style="font-size: 24px;margin-left: auto;">+</div>
										<div style="font-size: 12px;margin-left: 2px;margin-top: 4px;" class="d-flex a-center">添加到名片录</div>
									</div>
									<div class="d-flex a-center j-center" 
									style="width: 91px;height: 25px;background: #FFFFFF;border-radius: 13px;margin-top: 8px;font-size: 12px;">
										市场部经理
									</div>
								</div>
							</div>
							<div class="d-flex a-center" style="box-sizing: border-box;padding: 0 12px;margin-top: 41px;">
								<img style="width: 26px;height: 26px;" src="../../assets/Home/dianhua.png" />
								<div style="font-size: 15px;color: #FFFFFF;">181****8992</div>
								<img style="width: 26px;height: 26px;margin-left: auto;" src="../../assets/Home/dianhua.png" />
								<div style="font-size: 15px;color: #FFFFFF;">1258489676@168.com</div>
							</div>
							<div style="margin-top: 8px;" class="d-flex j-center">
								<div class="d-flex a-center">
									<img style="width: 30px;height: 30px;" src="../../assets/Home/shoushi.png" />
									<div @click="bgState=true" style="width: 127px;height: 30px;text-align: center;font-size: 14px;line-height: 30px;cursor: pointer;" 
									:style="'background: url('+djbj+')'">
										点击可更换背景
									</div>
								</div>
							</div>
							<img style="width: 355px;height: 142px;position: absolute;bottom: -46px;left: 10px;" src="../../assets/Home/zhongjian.png" />
						</div>
						<div>
							<img style="width: 100%;height: 394px;" src="../../assets/Home/ditu.png" />
						</div>
					</div>
					<img v-else-if="curIndex==2" style="width: 396px;height: 790px;" src="../../assets/Home/2.png" />
					<!-- <img v-else style="width: 396px;height: 790px;" src="../../assets/Home/3.png" /> -->
					<div v-else class="left-content">
						<div style="width: 100%;height: 375px;" 
						:style="'background: url('+tempBg+');'" class="img-top">
							<img style="width: 100%;height: 12px;" src="../../assets/Home/zhaungtailan.png" />
							<div class="d-flex a-center" style="box-sizing: border-box;padding: 5px 11px;">
								<img style="width: 16px;height: 16px;" src="../../assets/Home/fanhui.png" />
								<img style="width: 76px;height: 26px;margin-left: auto;" src="../../assets/Home/wxzt.png" />
							</div>
							<div style="margin-top: 76px;box-sizing: border-box;padding: 0 27px;">
								<div class="d-flex a-center" style="font-size: 18px;color: #FFFFFF;">
									小悠信息科技有限公司
									<img style="width: 14px;height: 14px;margin-left: 5px;" src="../../assets/Login/jiantou.png" />
								</div>
								<div style="background: rgba(255,255,255,0.3);color: #FFFFFF;font-size: 14px;width: 267px;
								text-align: center;border-radius: 4px;margin-top: 14px;">
									这是企业的宣传语，这是企业的宣传语。
								</div>
								<div style="margin-top: 14px;" class="d-flex a-center">
									<img style="width: 12px;height: 12px;" src="../../assets/Login/dizhi.png" />
									<div style="font-size: 12px;color: #FFFFFF;">广东省深圳市福田区八卦三路511栋</div>
								</div>
							</div>
							<div style="margin-top: 58px;" class="d-flex j-center">
								<div class="d-flex a-center">
									<img style="width: 30px;height: 30px;" src="../../assets/Home/shoushi.png" />
									<div @click="bgState=true" style="width: 127px;height: 30px;text-align: center;font-size: 14px;line-height: 30px;cursor: pointer;" 
									:style="'background: url('+djbj+')'">
										点击可更换背景
									</div>
								</div>
							</div>
						</div>
						<div>
							<img style="width: 100%;height: 394px;" src="../../assets/Home/xiamian.png" />
						</div>
					</div>
				</div>
			</div>
			<div class="right-box">
				<div class="message-admin">
					<div style="font-weight: 700;font-size: 16px;padding-top: 21px;">选择名片样式</div>
					<div class="d-flex">
						<div @click="setCurIndex(1)" style="text-align: center;width: 103px;height: 190px;border-radius: 6px;box-sizing: border-box;margin-top: 5px;"
						:style="curIndex==1?'border: 2px solid #1E69FF;':'border: 2px solid #ffffff;'">
							<img style="width: 86px;height: 159px;margin-top: 5px;cursor: pointer;" src="../../assets/Home/1.png" />
							<div style="font-size: 12px;text-align: center;">样式一</div>
						</div>
						<div @click="setCurIndex(2)" style="text-align: center;width: 103px;height: 190px;border-radius: 6px;box-sizing: border-box;margin-top: 5px;margin-left: 65px;"
						:style="curIndex==2?'border: 2px solid #1E69FF;':'border: 2px solid #ffffff;'">
							<img style="width: 86px;height: 159px;margin-top: 5px;cursor: pointer;" src="../../assets/Home/2.png" />
							<div style="font-size: 12px;text-align: center;">样式二</div>
						</div>
						<div @click="setCurIndex(3)" style="text-align: center;width: 103px;height: 190px;border-radius: 6px;box-sizing: border-box;margin-top: 5px;margin-left: 65px;"
						:style="curIndex==3?'border: 2px solid #1E69FF;':'border: 2px solid #ffffff;'">
							<img style="width: 86px;height: 159px;margin-top: 5px;cursor: pointer;" src="../../assets/Home/3.png" />
							<div style="font-size: 12px;text-align: center;">样式三</div>
						</div>
					</div>
				</div>
				
				<div style="background: #FFFFFF;border-radius: 6px;padding-top: 20px;margin-top: 20px;">
					<div style="box-sizing: border-box;padding: 0 27px;margin-bottom: 20px;font-weight: 700;">
						企业名片产品展示
					</div>
					<div style="height: 50px;background: #FFFFFF;margin-top: 16px;box-sizing: border-box;padding: 0 27px;"
					class="d-flex a-center j-sb">
						<el-radio @change="staff_card_set_product_show" v-model="product_show_type" label="0">默认无产品/服务</el-radio>
						<el-radio @change="staff_card_set_product_show" v-model="product_show_type" label="1">使用产品/服务列表</el-radio>
						<el-radio @change="staff_card_set_product_show" v-model="product_show_type" label="2">使用产品/服务分类</el-radio>
					</div>
				</div>
				
				<div class="message-list-box">
					<div class="d-flex a-center" style="font-size: 16px;">
						<div style="font-weight: 700;">员工列表</div> 
						<el-input v-model="keyword" style="width: 280px;margin-left: 130px;" size="small" placeholder="请输入内容" class="input-with-select">
							<el-button @click="searchKey" slot="append" type="primary" icon="el-icon-search"></el-button>
						</el-input>
						<div v-if="curIndex==2" style="margin-left: auto;display: flex;align-items: center;">
							<div style="width: 130px;font-size: 10px;font-weight: 500;">
								批量上传照片，照片名
								称与员工编号保持一致
							</div>
							<!-- <el-upload
							  action="https://www.spmall.com/seller/enterprise_publicity_manage_api.php"
							  multiple
							  :auto-upload="false"
							  :http-request="uploadFile"
							  :data="{act:'staff_card_logo_uploads2',token:token,user_id:'user_id',file:'file'}"
							  ref="upload">
							  <el-button size="small" type="primary">点击上传</el-button>
							</el-upload> -->
							<el-upload
							  action="https://www.spmall.com/seller/enterprise_publicity_manage_api.php"
							  multiple
							  :show-file-list="false"
							  :limit="9"
							  :on-exceed="exceed"
							  name="file"
							  :data="{act:'batch_logo_upload',token:token,user_id:user_id}">
							  <img style="width: 34px;height: 34px;" src="../../assets/Home/tianjia.png" />
							</el-upload>
							<!-- <el-upload
							  action="http://192.168.0.113/seller/enterprise_publicity_manage_api.php"
							  multiple
							  :show-file-list="false"
							  :limit="9"
							  :on-exceed="exceed"
							  name="file"
							  :data="{act:'batch_logo_upload',token:token,user_id:user_id}">
							  <img style="width: 34px;height: 34px;" src="../../assets/Home/tianjia.png" />
							</el-upload> -->
						</div>
					</div>
					
					<div style="height: 500px;overflow-y: scroll;">
						<!-- <el-button size=""></el-button> -->
						<el-table
						    :data="tableData"
							size="small"
						    style="width: 100%">
						    <el-table-column
						      prop="number"
						      label="员工编号"
						      width="80"
							  show-overflow-tooltip>
							  <template slot-scope="scope">
								<div style="text-align: center;">{{scope.row.number}}</div>
							  </template>
							</el-table-column>
						    <el-table-column
						      prop="company"
						      label="公司名称"
						      width="100"
							  align="center"
							  show-overflow-tooltip>
						    </el-table-column>
							<el-table-column
							  prop="name"
							  label="员工名称"
							  width="80"
							  align="center"
							  show-overflow-tooltip>
							</el-table-column>
							<el-table-column
							  prop="job"
							  label="职务"
							  align="center"
							  width="80"
							  show-overflow-tooltip>
							</el-table-column>
							<el-table-column
							  prop="micro_number"
							  label="联系方式"
							  align="center"
							  width="120"
							  show-overflow-tooltip>
							</el-table-column>
							<el-table-column
							  prop="email"
							  label="邮箱"
							  align="center"
							  show-overflow-tooltip>
							</el-table-column>
						    <el-table-column
							 v-if="curIndex==2"
						      label="头像"
							  align="right"
							  show-overflow-tooltip>
							  <template slot-scope="scope">
								<el-upload
								  action="https://www.spmall.com/seller/enterprise_publicity_manage_api.php"
								  :show-file-list="false"
								  name="file"
								  :data="{act:'staff_card_logo_upload',token:token,user_id:user_id,id:scope.row.id}">
								  <img style="width: 34px;height: 34px;" src="../../assets/Home/tianjia.png" />
								</el-upload>
							  </template>
						    </el-table-column>
						</el-table>
					</div>
					
					<!-- <div style="padding-top: 150px;text-align: center;">
						<img style="width: 150px;height: 150px;" src="../../assets/Home/zwsj@2x.png" />
					</div> -->
					<div @click="staff_card_publish_empty" class="d-flex a-center j-center" style="margin-top: 20px;">
						<div class="d-flex a-center j-center" style="width: 114px;height: 26px;background: #1E69FF;border-radius: 4px;
						font-size: 12px;color: #FFFFFF;cursor: pointer;">
							发布
						</div>
					</div>
					<div class="d-flex j-center" style="margin-top: 30px;">
						<el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,15]"
							:current-page.sync="currentPage" :page-size="pageSize" layout="sizes,prev, pager, next, total,jumper" :total="total_records">
						</el-pagination>
					</div>
					<!-- <el-button @click="submitUpload" size="small" type="primary">点击上传</el-button> -->
				</div>
			</div>
		</div>
		<el-dialog
		  title="提示"
		  :visible.sync="isshow"
		  width="390px"
		  :center="true"
		  top="30vh"
		  center>
		  <div style="height: 60px;background: #FFFFFF;border-radius: 10px;">
			  您还未添加任何产品/服务，建议您可以选择“默认无产品/服务或先去添加产品/服务
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button style="width: 120px;" size="small" @click="isshow = false">取消</el-button>
		    <el-button  size="small" type="primary" @click="$router.push('/item_store/publish_item')">去添加产品/服务</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="提示"
		  :visible.sync="isshow1"
		  width="390px"
		  top="30vh"
		  center>
		  <div style="height: 60px;background: #FFFFFF;border-radius: 10px;">
			  您还未添加任何产品/分类，建议您可以选择“默认无产品/服务或先去添加产品/分类
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button style="width: 120px;" size="small" @click="isshow1 = false">取消</el-button>
		    <el-button  size="small" type="primary"  @click="$router.push('/item_store/publish_serve')">去添加产品/分类</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		:modal="true"
		  title="商协会背景图设置"
		  :visible.sync="bgState"
		  width="1170px"
		  center>
		  <div style="height: 500px;overflow-y: scroll;" class="bg-box">
			  <div style="display: inline-block;box-sizing: border-box;
			  border-radius: 5px;cursor: pointer;border: 2px solid #fff">
				  <el-upload
					class=""
					action="upload"
					:show-file-list="false"
					:on-change="getAdBg"
					:http-request="()=>{}"
					accept='.jpg,.png'>
					<div style="width: 220px;height: 200px;display: flex;justify-content: center;align-items: center;">
					  <img style="width: 200px;height: 200px;border-radius: 5px;" src="../../assets/brand_fixtures/scbg.png">
					</div>
				  </el-upload>
			  </div>
			  <!--  -->
			  <div v-for="(item,index) in modelBg" style="display: inline-block;box-sizing: border-box;
			  border-radius: 5px;cursor: pointer;" @click="bgIndex=index"
			  :style="bgIndex===index?'border: 2px solid #1E69FF;':'border: 2px solid #fff;'">
				  <div  style="width: 220px;height: 220px;display: flex;justify-content: center;align-items: center;">
				  	<img style="width: 200px;height: 200px;border-radius: 5px;" :src="item.img_thumb">
				  </div>
			  </div>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="small" @click="bgState = false">取消</el-button>
		    <el-button  size="small" type="primary" @click="setBgModel">确定</el-button>
		  </span>
		</el-dialog>
	</div>

</template>

<script>
	
	export default {

		data() {
			return{
				curIndex:1,
				user_info:JSON.parse(localStorage.getItem('user_info')),
				fileData:"",
				token: localStorage.getItem('token'),
				user_id: localStorage.getItem('user_id'),
				currentPage: 1, //初始页
				pageSize : 10,
				tableData: [],
				total_records : 0,
				keyword:'',
				product_show_type:'0',
				isshow:false,
				isshow1:false,
				djbj:require('../../assets/Home/dianjigenghuan.png'),
				bgState:false,
				bgIndex:'',
				adBg:'',
				adid:'',
				modelBg:[],
				tempBg:'https://www.spmall.com/data/img_template/1634081823766007601.png'
			}
		},
		created() {
			if(localStorage.getItem('styleIndex')){
				this.curIndex = localStorage.getItem('styleIndex')
			}
			this.staff_card_list()
			this.get_company_info()
			this.enterprise_background_list()
		},
		methods:{
			//返回base64
			getBase64(file) {
			  return new Promise(function(resolve, reject) {
				const reader = new FileReader()
				let imgResult = ''
				reader.readAsDataURL(file)
				reader.onload = function() {
				  imgResult = reader.result
				}
				reader.onerror = function(error) {
				  reject(error)
				}
				reader.onloadend = function() {
				  resolve(imgResult)
				}
			  })
			},
			//获取背景图base64
			getAdBg(file, fileList){
				this.getBase64(file.raw).then((res) => {
					this.adBg = res
					this.tempBg = res
					this.adid = ''
					let aprams = {
						// act:'staff_card_set_style',
						act:'card_background_save',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						style_id:this.curIndex,
						img_tpl_id:this.adid,
						img_base64:this.adid?'':this.adBg
					}
					localStorage.setItem('styleIndex',this.curIndex)
					this.$api.staff_card_publish_empty(aprams).then((res)=>{
							this.bgState = false
					})
				})
			},
			setBgModel(){
				if(this.bgIndex!==''){
					this.adBg = this.modelBg[this.bgIndex].img_thumb
					this.tempBg = this.modelBg[this.bgIndex].img_thumb
					this.adid = this.modelBg[this.bgIndex].id
					let aprams = {
						// act:'staff_card_set_style',
						act:'card_background_save',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						style_id:this.curIndex,
						img_tpl_id:this.adid,
						img_base64:this.adid?'':this.adBg
					}
					localStorage.setItem('styleIndex',this.curIndex)
					this.$api.staff_card_publish_empty(aprams).then((res)=>{
						this.bgState = false
					})
				}
				
			},
			//背景模板
			enterprise_background_list(){
				let params = {
					act:'get_card_background_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.enterprise_background_list(params).then((res)=>{
					this.modelBg = res.data
				})
			},
			get_company_info(){
				let params = {
					act:'get_company_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0){
						this.product_show_type = res.data.product_show_type
						this.curIndex = res.data.card_style_id
						this.tempBg = res.data.card_photo_path
					}
				})
			},
			staff_card_set_product_show(){
				let params = {
					act : 'staff_card_set_product_show',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					product_show_type:this.product_show_type
				}
				this.$api.staff_card_set_product_show(params).then((res)=>{
					if(res.code==0){
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
					}else if(res.code == 2){
						this.isshow = true
					}else if(res.code == 3){
						this.isshow1 = true
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			setCurIndex(index){
				this.curIndex = index
			},
			uploadFile(file) {
				this.fileData.append('files', file.file);
			},
			exceed(){
				this.$message({
					showClose: false,
					message: '最多批量上传9张图片',
					type: 'errot',
					offset: 350
				})
			},
			submitUpload() {
				this.fileData = new FormData();
				this.$refs.upload.submit();
				this.fileData.append('act', 'staff_card_logo_uploads');
				this.fileData.append('token', this.token);
				this.fileData.append('user_id', this.user_id);
				this.$axios.post('http://www.spmall.com/seller/enterprise_publicity_manage_api.php',
				this.fileData).then((res) => {
					
				})
			},
			handleSizeChange(size) {
				this.pageSize = size;
				this.staff_card_list()
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.staff_card_list()
			},
			searchKey(){
				this.currentPage = 1;
				this.staff_card_list()
			},
			staff_card_list(){
				let param = {
					act : 'staff_card_list',
					// act:'fcib_member_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					status : 1,
					keyword : this.keyword,
					page : this.currentPage,
					size : this.pageSize
				}
				this.$api.staff_card_list(param).then((res)=>{
					this.tableData = []
					if(res.code == 0){
						res.data.forEach((item) => {
							this.tableData.push({...item,is_confirm:item.status==1?true:false})
						})
						this.total_records = parseInt(res.total_records)
					}
				})
			},
			staff_card_publish_empty(){
				let aprams = {
					act:'staff_card_set_style',
					// act:'card_background_save',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					style_id:this.curIndex,
					// img_tpl_id:this.adid,
					// img_base64:this.adid?'':this.adBg
				}
				localStorage.setItem('styleIndex',this.curIndex)
				this.$api.staff_card_publish_empty(aprams).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '发布成功',
							type: 'success',
							offset: 350
						})
						this.get_company_info()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.img-top{
		background-size: 100% 100%!important;
	}
	.content-box{
		width: 1170px;
		min-height: 960px;
		border-radius: 6px;
		display: flex;
	}
	.left-content{
		box-sizing: border-box;
		width: 396px;
		height: 790px;
		border-radius: 14px;
		border: 10px solid #0C275E;
		position: relative;
		background: #F5F5F5;
		overflow-y: scroll;
	}
	.left-content::-webkit-scrollbar{
		display: none;
	}
	.tabbar-box{
		height: 50px;
		background: #FFFFFF;
		box-shadow: 0px -10px 20px 0px rgba(209, 209, 209, 0.48);
		border-radius: 0 0 10px 10px;
		padding: 0 13px;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
	}
	.left-box{
		width: 440px;
		background: #FFFFFF;
		box-sizing: border-box;
		border-radius: 6px;
		padding-left: 19px;
	}
	.right-box{
		margin-left: 20px;
		flex: 1;
	}
	.message-admin{
		width: 100%;
		height: 240px;
		background: #FFFFFF;
		border-radius: 6px;
		box-sizing: border-box;
		padding: 0px 20px;
	}
	.message-list-box{
		width: 100%;
		height: 702px;
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 20px;
		box-sizing: border-box;
		padding: 20px 25px;
	}
	.message-list{
		height: 800px;
		overflow-y: scroll;
		box-sizing: border-box;
		padding: 0 20px;
	}
	.message-item-box{
		margin-top: 20px;
		height: 87px;
	}
	.img-boxs::-webkit-scrollbar{
		background: #f5f5f5;
		width: 5px;
	}
	.img-boxs::-webkit-scrollbar-thumb {
		/*滚动条里面的条*/
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #CCCCCC;
		width: 5px;
	}
	.text-hide{
		overflow:hidden;
		text-overflow:ellipsis;
		display:-webkit-box; 
		-webkit-box-orient:vertical;
		-webkit-line-clamp:1;
	}
	.text-hide-2{
		overflow:hidden; 
		text-overflow:ellipsis;
		display:-webkit-box; 
		-webkit-box-orient:vertical;
		-webkit-line-clamp:2;
	}
	.bg-box::-webkit-scrollbar{
		display: none;
	}
</style>
